var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('v-icon',{attrs:{"size":"1.5rem"}},[_vm._v(" mdi-history ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }